export const draftDialogAllSelector = (state) =>
  state?.draftDialogReducer?.draftDialogAll;
export const draftDialogOpenAddSelector = (state) =>
  state?.draftDialogReducer?.draftDialogOpenAdd;
export const draftDialogOpenEditSelector = (state) =>
  state?.draftDialogReducer?.draftDialogOpenEdit;
export const draftDialogSelectedSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSelected;
export const draftDialogSearchSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSearch;
//
export const draftDialogDetailSelector = (state) =>
  state?.draftDialogReducer?.draftDialogDetail;
//
export const draftDialogIndexSelector = (state) =>
  state?.draftDialogReducer?.draftDialogIndex;
export const draftDialogPlaySelector = (state) =>
  state?.draftDialogReducer?.draftDialogPlay;
export const draftDialogSecondSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSecond;
export const draftDialogUrlSelector = (state) =>
  state?.draftDialogReducer?.draftDialogAudioUrl;
export const draftDialogRentTaskSelector = (state) =>
  state?.draftDialogReducer?.draftDialogRentTask;
//
export const draftDialogSelectedRange = (state) =>
  state?.draftDialogReducer?.draftDialogSelectedRange;
